import BaseModel from '../core/BaseModel'
//import UserModel from '@/models/UserModel'
export default class RentalOrderModel extends BaseModel {

    constructor() {
        super({
                name: "rental_order_rent",
                tableName: 'rental_order_rent',
                label: "rental_order_rent",
                display_key: 'name'
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                // code: {
                //     name: 'code',
                //     type: "String",
                //     label: 'code',
                //     display: false
                // },
                // term_id: {
                //     name: 'term_id',
                //     type: "Uuid",
                //     label: 'term_id',
                //     display: false
                // },
            })
    }

}